import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import useAnalyticEvent, { PageName } from '../../../hooks/useAnalyticEvent';
import { APP_BASE_PATH } from '../../../shared/appBasePath';
import { buildNavigationUrl } from '../../../shared/routes';

const VehicleEntry = dynamic(() => import('@carvana/helios-composites/VehicleEntry'));

const wizardRoute = `${APP_BASE_PATH}/get-value/vehicle`;

type SubmitPlateVin = { vin: string } | { plate: string; plateState: string };
enum SubmissionType {
  Vin = 'Vin',
  PlateState = 'Plate/State'
}

const VehicleEntryContainer = () => {
  const router = useRouter();
  const { recordEventAndNavigateTo } = useAnalyticEvent();

  const handleRedirect = (submitData: Record<string, string>, redirectUrl: string) => {
    const submissionType = 'vin' in submitData ? SubmissionType.Vin : SubmissionType.PlateState;

    recordEventAndNavigateTo(
      redirectUrl,
      PageName.Marketing,
      `Track My Value Hero - ${submissionType} submission`,
      { ...submitData }
    );
  };

  const submitPlateVin = (info: SubmitPlateVin) => {
    const sendToWizard: { vin: string } | { licensePlate: string; plateState: string } =
      'vin' in info ? { vin: info.vin } : { licensePlate: info.plate, plateState: info.plateState };

    const redirectUrl = buildNavigationUrl(wizardRoute, sendToWizard);
    handleRedirect(sendToWizard, redirectUrl);
  };

  const queryParams = router?.query;

  return (
    <VehicleEntry
      submitPlateVin={submitPlateVin}
      submitText="Track My Value"
      queryParams={queryParams}
    />
  );
};

export default VehicleEntryContainer;
